// import noImageSrc from '../../../../src/img/NoImageAvailable.jpg'
import noImageSrc from '../../../../../src/img/NoImageAvailable.jpg';

export const DepartmentEmployeesHeader = [
  {
    headerName: 'Sl No.',
    field: 'sl_no',
    // sortable: true,
  },
  {
    headerName: 'Name',
    field: 'name',
    // sortable: true,
  },
  {
    field: 'photo',
    headerName: 'Photo',
    width: 100,
    renderCell: (params) => {
      return (
        <div
          key={params.row.sl_no}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100%',
            padding: '4px',
          }}
        >
                    
          <img
            src={`${params.row.photo ? `https://workspace.teaminterval.net/assets/employee/photo/passport_size/${params.row.photo}.jpg` : noImageSrc} `}
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            onError={(e) => {
              e.target.onerror = null; // Prevent infinite loop
              e.target.src = noImageSrc;
            }}
          />
                    {/* <img src={noImageSrc } style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> */}
                  
        </div>
      );
    },
  },
  {
    headerName: 'Designation',
    field: 'designation',
    // sortable: true,
    width: 250,
    toolTipGetter: true,
  },
  {
    headerName: 'Parent',
    field: 'parentName',
    // sortable: true,
  },
  {
    headerName: 'DOB',
    field: 'doteOfBirth',
    // sortable: true,
  },
  {
    headerName: 'Date Of Joining',
    field: 'jod',
    // sortable: true,
  },
  {
    headerName: 'Mobile No',
    field: 'mobNo',
    // sortable: true,
  },
  {
    headerName: 'Email',
    field: 'personalEmail',
    // sortable: true,
    toolTipGetter: true,
    width: 250,
  },
  {
    headerName: 'Qualification',
    field: 'course',
    // sortable: true,
    toolTipGetter: true,
    width: 250,
  },
];
